import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
import {ErrorMessage, Form} from "formik";
import clsx from "clsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useHistory } from "react-router-dom";
import URLS from '../../../config/navigation';
import { useDispatch, useSelector } from "react-redux";
import { selectProfileInfo, selectProfileUrl } from "../../../store/selectors/Profile";
import {
    matchProfileUrl,
    setupProfilePublicUrl,
    getSelfProfileInfo
} from "../../../store/entities/Profile/Profile.actions";
import TextBox from '../../Common/Textbox/small'
import Button from '../../Common/Buttons/small'
import LinkButton from '../../Common/Buttons/linkButton'
import { ProfileUrlValidation } from "../../../utils/profileUrlValidation";
import { FormHelperText } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CheckIcon from "@material-ui/icons/Check";
import Toast from "../../Common/Toast";
import ToastMessage from "../../Common/ToastMessage";

const LinkGenerator = () => {

    const history = useHistory();
    const ProfileInfo = useSelector(selectProfileInfo);
    const [profileInfo,setProfileInfo] = useState(false)
    const dispatch = useDispatch()
    const [error, setError] = useState(null);
    const [value, setValue] = useState(undefined);
    const [flag, setFlag] = useState(false);
    const [handle, setHandle] = useState(false);

    const callback = (response) => {
        setFlag(response.data)
    };

    const matchCallback = async (response) => {
        if (response.data) {
            if(ProfileInfo.firstName){
                const newValue = value ? (value + "1") : (`${ProfileInfo.firstName}${ProfileInfo.secondName}` + "1");
                setValue(newValue);
                setHandle(!handle)
            }
        }else {
            setFlag(response.data)
        }
    };

    const handleChange = (event) => {
        dispatch(matchProfileUrl(event.target.value, callback));
        const validationArray = ProfileUrlValidation.split(',');
        setValue(event.target.value);
        const regx = /^[a-zA-Z0-9]{2,30}\S$/;
        if ((validationArray.find(item =>
            item.trim() === event?.target?.value.toLocaleLowerCase().trim())?.length > 1
            || !event?.target?.value.match(regx)) && event?.target?.value) {
            return setError(true)
        }
        setError(false)
    };

    const matchValue = async (link) => {
        await dispatch(matchProfileUrl((link), matchCallback))
    };

    const getSelfCallback = (response) => {
        if(response.data){
            if(response.data.publicUrlName && response.data.publicUrlName!=="" && response.data.publicUrlName!==null && response.data.publicUrlName!=="null"){
                let link = response.data.publicUrlName.replace(/\s+/g, '');
                setValue(link);
            }
            else
            {
                let link = `${response.data.firstName}${response.data.secondName}`;
                let linkClean = link.replace(/\s+/g, '')
                setValue(linkClean);
                matchValue(linkClean)
            }
            setProfileInfo(response.data)
        }

    }

    useEffect(() => {
        dispatch(getSelfProfileInfo(getSelfCallback))

    }, []);

    useEffect( () => {
        matchValue(value)
    }, [handle]);

    const handleContinue = () => {

        dispatch(setupProfilePublicUrl(
            value,
            () => history.push(URLS.PUBLIC.PREVIEW_CONNECT_BANK_ACC),
            () => Toast(ToastMessage(5), "error")
        ));
    }
    const handleBack = () => {
        history.push(URLS.PUBLIC.SETUP)
    }

    return (
        <div className={"generatorContainer"}>
            <div className={"wrapper"}>
                <label className={"inputContainer"}>

                    <TextBox placeholder="" error={!!error || !!flag} value={value===undefined ? "" : value} type={"text"} InputProps={{
                        startAdornment: <InputAdornment position="start">teachon.org/</InputAdornment>,
                        endAdornment: (!error && value) && <InputAdornment position="end">
                            {(!error && !flag) && (<CheckIcon  style={{color: "green",marginRight:5}} /> )}
                        </InputAdornment>
                    }}
                             handleChange={handleChange} tName={"link"} label={"Public Profile Link"}
                             additionClass={'EMPHASIS_LARGE smallInput'} htmlFor="outlined-basic-link"/>

                    {(error || flag) && (
                        <FormHelperText error={error || flag}>This link has already been taken. Please select a
                            different name.</FormHelperText>)}
                </label>
            </div>

            <div className={"CENTER_FLEX"}>
                <div className={"END_FLEX FLEX_100"}>

                    <LinkButton handleClick={handleBack} additionClass={""} text={"Back"}/>
                    <Button disabled={error || flag} handleClick={handleContinue} loading={value ===undefined  ? true : !value.length} additionClass={""} text={"Continue"}/>

                </div>
            </div>
        </div>
    )
}

export default LinkGenerator
